import React, { useEffect, useState } from "react"
import { FormLabel, Grid, InputAdornment, setRef } from "@mui/material"
import AppDialog from "../../../components/Common/AppDialog"

import '../order.css';
import CustomTextField from "../../../components/Form/CustomTextField";
import RadioButtonGroup from "../../../components/Form/RadioButtonGroup";
import CheckBox from "../../../components/Form/CheckBox";
import Label from "../../../components/Common/Label";
import Notification from "../../../components/Common/Notification";
import Helpers from "../../../helpers/helpers";

const RefundOrder = (props) => {
    const [refundType, setRefundType] = useState('payment');
    const [refundAmount, setRefundAmount] = useState();
    const [productRefund, setProductRefund] = useState();
    const [productAddOnRefund, setProductAddOnRefund] = useState();
    const [selectedRefundProduct, setSelectedRefundProduct] = useState([]);
    const [refundedProduct, setRefundedProduct] = useState([]);
    const [selectedRefundAddOnProduct, setSelectedRefundAddOnProduct] = useState([]);
    const [refundedAddOnProduct, setRefundedAddOnProduct] = useState([]);
    const [maxRefundAmount, setMaxRefundAmount] = useState(0);
    const [maxRefundPoint, setMaxRefundPoint] = useState(0);
    const [notification, setNotification] = useState({ open: false, msg: '', type: 'success' });

    const refundList = [
        { label: 'Amount', value: 'payment' },
        { label: 'Store credit (Points)', value: 'points' }
    ]
    useEffect(() => {
        if (props?.refundData?.length > 0) {
            let refundData = props?.refundData;
            let refundProductList = [];
            let refundedProductList = [];
            let refundProductAddOnList = [];
            let refundedProductAddOnList = [];
            let addOnData = refundData.filter(item => item?.addons?.length > 0);
            let maximumRefundAmount = 0;
            let maximumRefundPoint = 0;

            props?.refundData.map((item) => {
                maximumRefundAmount += item?.refund_max_amount || 0;
                maximumRefundPoint += item?.refund_max_point || 0;
                item?.addons?.length > 0 && item?.addons.map((addon) => {
                    maximumRefundAmount += addon?.refund_max_amount || 0;
                    maximumRefundPoint += addon?.refund_max_point || 0;
                })
            })

            refundData = refundData.filter(item => item?.product_type === 'simple');
            refundData?.length > 0 && refundData.map((item) => {
                let ableRefundQuantity = item?.quantity - (item?.refunded_quantity || 0);
                if (item?.refunded_quantity > 0) {
                    for (let i = 0; i < item?.refunded_quantity; i++) {
                        let currentItem = item;
                        // currentItem.refund_id = `${item.id}_${i + 1}`;
                        refundedProductList.push({ ...currentItem });
                    }
                }
                if ((ableRefundQuantity) <= 0) {
                    refundData = refundData.filter(refundItem => refundItem.id !== item.id);
                } else {
                    if (item.quantity > 1) {
                        for (let i = 0; i < ableRefundQuantity; i++) {
                            let currentItem = item;
                            currentItem.refund_id = `${item.id}_${i + 1}`;
                            refundProductList.push({ ...currentItem });
                        }
                    } else {
                        item.refund_id = `${item.id}_0`;
                        refundProductList.push({ ...item });
                    }
                    // item.refund_id = `${item.id}_0`;
                }
            })
            addOnData?.length > 0 && addOnData.map((item) => {
                item?.addons?.length > 0 && item?.addons.map((addon) => {
                    let ableRefundQuantity = addon?.quantity - (addon?.refunded_quantity || 0);
                    if (addon?.refunded_quantity > 0) {
                        for (let i = 0; i < addon?.refunded_quantity; i++) {
                            let currentItem = addon;
                            // currentItem.refund_id = `${item.id}_${i + 1}`;
                            refundedProductAddOnList.push({ ...currentItem });
                        }
                    }
                    if ((ableRefundQuantity) <= 0) {
                        refundData = refundData.filter(refundItem => refundItem.id !== addon.id);
                    } else {
                        if (addon.quantity > 1) {
                            for (let i = 0; i < ableRefundQuantity; i++) {
                                let currentItem = addon;
                                currentItem.refund_id = `addon_${addon.id}_${i + 1}`;
                                refundProductAddOnList.push({ ...currentItem });
                            }
                        } else {
                            addon.refund_id = `addon_${addon.id}_0`;
                            refundProductAddOnList.push({ ...addon });
                        }
                        // item.refund_id = `${item.id}_0`;
                    }
                })
            })
            setRefundAmount('0.00');
            setProductRefund(refundProductList);
            setRefundedProduct(refundedProductList);
            setProductAddOnRefund(refundProductAddOnList);
            setRefundedAddOnProduct(refundedProductAddOnList);
            setMaxRefundAmount(maximumRefundAmount);
            setMaxRefundPoint(maximumRefundPoint);
        }
    }, [props?.refundData])

    useEffect(() => {
        if (selectedRefundProduct) {
            calculateRefundAmount();
        }
    }, [selectedRefundProduct, selectedRefundAddOnProduct, refundType])

    const handleSubmit = () => {
        let payload = {
            refund_type: refundType,
            refund_amount: refundAmount,
            product_refund: selectedRefundProduct,
            addon_items: selectedRefundAddOnProduct
        }
        props.submit(payload);
        resetRefundData();
    }

    const handleSetRefundProduct = (product) => {
        let selectedProduct = selectedRefundProduct;
        if (selectedProduct.includes(product)) {
            selectedProduct = selectedProduct.filter(item => item?.refund_id !== product?.refund_id);
            setSelectedRefundProduct([...selectedProduct]);
            return;
        }
        selectedProduct.push(product);
        setSelectedRefundProduct([...selectedProduct]);
    }
    const handleSetRefundAddOnProduct = (product) => {
        let selectedProduct = selectedRefundAddOnProduct;
        if (selectedProduct.includes(product)) {
            selectedProduct = selectedProduct.filter(item => item?.refund_id !== product?.refund_id);
            setSelectedRefundAddOnProduct([...selectedProduct]);
            return;
        }
        selectedProduct.push(product);
        setSelectedRefundAddOnProduct([...selectedProduct]);
    }

    const calculateRefundAmount = () => {
        let totalRefundAmount = 0;
        selectedRefundProduct?.length > 0 && selectedRefundProduct.map((item) => {
            let totalAmount = (refundType === "points" ? item?.refund_max_point : item?.refund_max_amount) || 0;
            if (item?.quantity > 1) {
                totalAmount = totalAmount / item?.quantity;
            }
            totalRefundAmount += totalAmount;
        })
        selectedRefundAddOnProduct?.length > 0 && selectedRefundAddOnProduct.map((item) => {
            let totalAmount = (refundType === "points" ? item?.refund_max_point : item?.refund_max_amount) || 0;
            if (item?.quantity > 1) {
                totalAmount = totalAmount / item?.quantity;
            }
            totalRefundAmount += totalAmount;
        })
        setRefundAmount(Number(totalRefundAmount).toFixed(2));
    }

    const handleRefundAmount = (amount) => {
        if (amount && Number(amount) > (refundType === "points" ? maxRefundPoint : maxRefundAmount)) {
            setNotification({ open: true, msg: `Refund amount should not exceed ${refundType === "points" ? maxRefundPoint + ' points' : 'S$' + maxRefundAmount} `, type: 'error' });
            return;
        } else {
            setRefundAmount(amount);
        }
    }

    const resetRefundData = () => {
        setRefundType('payment');
        setRefundAmount('');
        setSelectedRefundProduct([]);
        setSelectedRefundAddOnProduct([]);
    }
    
    return (
        <AppDialog
            open={props.open}
            close={() => {props.close(); resetRefundData()}}
            title={'Refund'}
            titleIcon={'warning'}
            positiveTitle={'Refund order'}
            positivePress={() => handleSubmit()}
            negativePress={() => {props.close(); resetRefundData()}}
            negativeTitle={'Cancel'}
            width={'50%'}
        >
            <div className="">
                <Notification notification={notification} setNotification={setNotification} />
                <Grid container spacing={2}>
                    <Grid item sm={6} xs={12}>
                        <RadioButtonGroup
                            title={'Type of refund'}
                            value={refundType}
                            data={refundList}
                            setValue={setRefundType}
                            required="true"
                            name="status"
                        />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <CustomTextField
                            title={refundType === 'points' ? 'Store credit (Points)' : 'Amount'}
                            values={refundAmount}
                            onChange={(e) => handleRefundAmount(e)}
                            type={'number'}
                            placeholder={'0.00'}
                            InputProps={{
                                startAdornment: refundType === 'payment' && <InputAdornment position="start" className='auth-icon'>S$</InputAdornment>,
                                endAdornment: refundType === 'points' && <InputAdornment position="end" className='auth-icon'>points</InputAdornment>,
                            }}
                        />
                    </Grid>
                    {
                        (productRefund?.length > 0 || productAddOnRefund?.length > 0) &&
                        <Grid item sm={12} md={12} >
                            <FormLabel style={{ fontFamily: 'Manrope-Semibold', fontSize: 14 }}>
                                {'Select products to be returned/refunded'}
                            </FormLabel>
                        </Grid>
                    }
                    {
                        productRefund?.length === 0 && productAddOnRefund?.length === 0 &&
                        <Grid item sm={12} md={12} >
                            <FormLabel style={{ fontFamily: 'Manrope-Semibold', fontSize: 14 }}>
                                {'No products available for refund'}
                            </FormLabel>
                        </Grid>
                    }
                    {
                        productRefund?.length > 0 && productRefund?.map((item, idx) => {
                            return (
                                <Grid item sm={12} md={12} display={'flex'} key={idx}>
                                    <CheckBox
                                        values={selectedRefundProduct.filter(product => product?.refund_id === item?.refund_id).length > 0}
                                        onChange={(e) => handleSetRefundProduct(item)}
                                    />
                                    <Grid container>
                                        <Grid item md={2} sm={3} xs={12} textAlign={'left'} className="">
                                            <img src={item?.product_thumbnail || Helpers.noImageLink} alt="product-image" style={{ height: 42, width: 56 }} />
                                        </Grid>
                                        <Grid item md={10} sm={9} xs={12} textAlign={'left'} className="subheader">
                                            <div className="subheader d-flex align-items-center">{item?.product_name || 'N/A'} <Label.ItemTag label={item?.product_type} /></div>
                                            <div className="subheader-2 font-size-12">SKU: {item?.sku}</div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )
                        })
                    }
                    {
                        refundedProduct?.length > 0 && refundedProduct?.map((item, idx) => {
                            return (
                                <Grid item sm={12} md={12} display={'flex'} key={idx} style={{ opacity: 0.5 }}>
                                    <CheckBox
                                        values={selectedRefundProduct.filter(product => product?.refund_id === item?.refund_id).length > 0}
                                        onChange={(e) => handleSetRefundProduct(item)}
                                        disabled={true}
                                    />
                                    <Grid container>
                                        <Grid item md={2} sm={3} textAlign={'left'} className="">
                                            <img src={item?.product_thumbnail || Helpers.noImageLink} alt="product-image" style={{ height: 42, width: 56 }} />
                                        </Grid>
                                        <Grid item md={10} sm={9} textAlign={'left'} className="subheader">
                                            <div className="subheader d-flex align-items-center">{item?.product_name || 'N/A'} <Label.ItemTag label={item?.product_type} /><Label.RefundedLabel /></div>
                                            <div className="subheader-2 font-size-12">SKU: {item?.sku}</div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )
                        })
                    }
                    {
                        (productAddOnRefund?.length > 0 || refundedAddOnProduct?.length > 0) &&
                        <Grid item sm={12} md={12} display={'flex'} className="text-semibold">
                            <FormLabel style={{ fontFamily: 'Manrope-Semibold', fontSize: 14 }}>Add on product(s):</FormLabel>
                        </Grid>
                    }
                    {
                        productAddOnRefund?.length > 0 && productAddOnRefund?.map((item, idx) => {
                            return (
                                <Grid item sm={12} md={12} display={'flex'} key={idx}>
                                    <CheckBox
                                        values={selectedRefundAddOnProduct.filter(product => product?.refund_id === item?.refund_id).length > 0}
                                        onChange={(e) => handleSetRefundAddOnProduct(item)}
                                    />
                                    <Grid container>
                                        <Grid item md={2} sm={3} xs={12} textAlign={'left'} className="">
                                            <img src={item?.product_thumbnail || Helpers.noImageLink} alt="product-image" style={{ height: 42, width: 56 }} />
                                        </Grid>
                                        <Grid item md={10} sm={9} xs={12} textAlign={'left'} className="subheader">
                                            <div className="subheader d-flex align-items-center">{item?.product_name || 'N/A'} <Label.ItemTag label={item?.product_type} /></div>
                                            <div className="subheader-2 font-size-12">SKU: {item?.product_sku}</div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )
                        })
                    }
                    {
                        refundedAddOnProduct?.length > 0 && refundedAddOnProduct?.map((item, idx) => {
                            return (
                                <Grid item sm={12} md={12} display={'flex'} key={idx} style={{ opacity: 0.5 }}>
                                    <CheckBox
                                        values={selectedRefundProduct.filter(product => product?.refund_id === item?.refund_id).length > 0}
                                        onChange={(e) => handleSetRefundProduct(item)}
                                        disabled={true}
                                    />
                                    <Grid container>
                                        <Grid item md={2} sm={3} textAlign={'left'} className="">
                                            <img src={item?.product_thumbnail || Helpers.noImageLink} alt="product-image" style={{ height: 42, width: 56 }} />
                                        </Grid>
                                        <Grid item md={10} sm={9} textAlign={'left'} className="subheader">
                                            <div className="subheader d-flex align-items-center">{item?.product_name || 'N/A'} <Label.ItemTag label={item?.product_type} /><Label.RefundedLabel /></div>
                                            <div className="subheader-2 font-size-12">SKU: {item?.product_sku}</div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )
                        })
                    }
                </Grid>

            </div>
        </AppDialog>
    )
}

export default RefundOrder;